import { useRef, useCallback } from "react";
import { ALL_FIELDS_MARKER } from "./types";
export var useStoreMetadata = function(initialStore) {
    var store = useRef(initialStore);
    var subscribers = useRef(new Map());
    var globalSubscribers = useRef(new Set());
    var get = useCallback(function() {
        return store.current;
    }, []);
    var set = useCallback(function(selector) {
        var partialStore = typeof selector === "function" ? selector(store.current) : selector;
        var changedFields = Object.keys(partialStore).filter(function(field) {
            return store.current[field] !== partialStore[field];
        });
        if (changedFields.length === 0) {
            return;
        }
        store.current = Object.assign({}, store.current, partialStore);
        // Notify consumers that use the changed fields
        changedFields.forEach(function(field) {
            var fieldSubscribers = subscribers.current.get(field);
            if (fieldSubscribers) {
                fieldSubscribers.forEach(function(callback) {
                    return callback();
                });
            }
        });
        globalSubscribers.current.forEach(function(callback) {
            return callback();
        });
    }, []);
    var subscribe = useCallback(function(callback, fields) {
        if (fields !== ALL_FIELDS_MARKER) {
            // Add the callback to the subscribers for each field
            fields.forEach(function(field) {
                var fieldSubscribers = subscribers.current.get(field);
                if (fieldSubscribers) {
                    fieldSubscribers.add(callback);
                } else {
                    subscribers.current.set(field, new Set([
                        callback
                    ]));
                }
            });
        } else {
            globalSubscribers.current.add(callback);
        }
        // Return a function to unsubscribe from all fields
        return function() {
            if (fields !== ALL_FIELDS_MARKER) {
                fields.forEach(function(field) {
                    var fieldSubscribers = subscribers.current.get(field);
                    if (fieldSubscribers) {
                        var deleted = fieldSubscribers.delete(callback);
                        if (!deleted) {
                            // eslint-disable-next-line no-console
                            console.warn("useStore with fields ".concat(fields, " could not unsubscribe from field ").concat(String(field)));
                        }
                    }
                });
            } else {
                globalSubscribers.current.delete(callback);
            }
        };
    }, []);
    return {
        get: get,
        set: set,
        subscribe: subscribe
    };
};
